import React, { useContext, useState, useEffect} from 'react';
 import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 

import tbl from '../../../../assets/Style/Table.module.css'
import { useLog } from '../../../../hooks/useLog';
import LogItem from './Item';
import { selectStyle } from './selectStyle';
import Select from 'react-select';
import Search from '../../../UI/Search/Search';
import { useUser } from '../../../../hooks/useUser';

import { baseFileURL } from '../../../../Api';
import { useTranslation } from 'react-i18next';

const List = () => {

    const {t} = useTranslation();
  const {appState, app} = useContext(AppContext);
  const formatDate = (dateString) => {

    const newAtDate = new Date(dateString);

    const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];

    const day = newAtDate.getDate();
    const month = months[newAtDate.getMonth()];
    const year = newAtDate.getFullYear();
    const hours = String(newAtDate.getHours()).padStart(2, '0');
    const minutes = String(newAtDate.getMinutes()).padStart(2, '0');

    return `${day} ${month} ${year} ${hours}:${minutes}`;

  };

    

  const defaultPageSize = 100; 
  const isFetch = true;   
  const roleId = null;  

  const { userService } = useUser(defaultPageSize, isFetch, roleId); 
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const users = await userService.fetchList();   
        const options = users.map(user => ({
          label: `${user.firstname} ${user.lastname}`,
          value: user.id
        }));
        setUserOptions(options);
        console.log("Fetched Users:", users);  
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    
    fetchUsers();  
  }, []);  

  

  const options = [
    { value: 1, label: t('AddCar') },
    { value: 2, label: t('UpdateCar') },
    { value: 3, label: t('DeleteCar') },
    { value: 4, label: t('AddUser') },
    { value: 5, label: t('EditUser') },
    { value: 6, label: t('DeleteUser') },
    { value: 7, label: t('UpdateClientPrice') },
    { value: 8, label: t('AddTransaction') },
    { value: 9, label: t('DeleteTransaction') },
    { value: 10, label: t('RefundPayment') },
    { value: 11, label: t('ReplacePayment') },
    { value: 12, label: t('AddContainer') },
    { value: 13, label: t('UpdateContainer') },
    { value: 14, label: t('UpdateContainerCompanyPrice') },
    { value: 15, label: t('UpdateContainerClientPrice') },
    //{ value: 16, label: t('კონტეინერის გახსნის დროის განახლება') },
    //{ value: 17, label: t('კონტეინერის აღების დროის განახლება') },
    //{ value: 18, label: t('კონტეინერის შესვლის დროის განახლება') },
    //{ value: 19, label: t('კონტეინერის გაგზავნის დროის განახლება') },
    { value: 20, label: t('DeleteContainer') },
    { value: 21, label: t('CreateCargo') },
    { value: 22, label: t('DeleteCargo') },
    { value: 23, label: t('UpdateCargo') },
    { value: 24, label: t('CreateContainerTransaction') },
    { value: 25, label: t('CreateCargoTransaction') },
    { value: 26, label: t('DeleteContainerOrCargoTransaction') },
    { value: 27, label: t('AddInvoice') },
    { value: 28, label: t('DeleteInvoice') },
    { value: 30, label: t('UpdateContainerPrice') }
  ];
  
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    logService.setFilter({
      ...logService.filter,
      [name]: value,
      page: 1,
    });

 
    if (name === 'car_id') {
      const intValue = parseInt(value, 10); 
      if (!isNaN(intValue)) {
          logService.setFilter({
              ...logService.filter,
              [name]: intValue,
              page: 1,
          });
      }
    }  
 
    if (name === 'container_id') {
      const intValue = parseInt(value, 10); 
      if (!isNaN(intValue)) {
          logService.setFilter({
              ...logService.filter,
              [name]: intValue,
              page: 1,
          });
      }
    }  
 
    if (name === 'cargo_id') {
      const intValue = parseInt(value, 10); 
      if (!isNaN(intValue)) {
          logService.setFilter({
              ...logService.filter,
              [name]: intValue,
              page: 1,
          });
      }
    }  


  
  };


  const getTypeName = (type_id) => {
    const option = options.find(option => option.value === type_id);
    return option ? option.label : '';
  }
  
 
  const { logService } = useLog(50); 

  useEffect( ()=> {
    logService.fetchList()
  }, [])
   
  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Logs')}</h1>   
     </div>

     <div className={ cl.searchBox }>
 
            <div className={cl.col} >
              <div className={cl.inBox}> 
                <input
                    name="query" 
                    placeholder={t('Search')}
                    className={cl.input}
                    value={logService.filter.query}
                    onChange={handleInputChange}
                />
              </div>
            </div>


            {
                      baseFileURL === "https://finance.automoby.ge"  ||  baseFileURL === "https://crm.aig.com.ge"  ||  baseFileURL === "https://crmdev.aig.com.ge" || baseFileURL === "https://crm.autonomo.kz"
                      ? 
                       <>
                                    
                            

                            <div className={cl.col} >
                                <div className={cl.inBox}> 
                                        <input 
                                            name="car_id"
                                            className={cl.input}
                                            placeholder={t('CarID')}
                                            value={logService.filter.car_id}
                                            onChange={handleInputChange}
                                        />
                                </div>
                            </div>

                       </> 
                      : baseFileURL === "https://i-logistics.net" ||  baseFileURL === "https://dev.i-logistics.net"
                      ? <>
 
                            <div className={cl.col} >
                              <div className={cl.inBox}> 
                                      <input 
                                          name="container_id"
                                          className={cl.input}
                                          placeholder={t('ContainerID')}
                                          value={logService.filter.container_id}
                                          onChange={handleInputChange}
                                      />
                              </div>
                            </div>

                             
  
                        </> 
                      : "" 
                  }

 

   
 
            <div className={cl.col} >
              <div className={cl.inBox }> 
                <Select
                    styles={selectStyle}

                    options={userOptions} 
                    value={userOptions.find(option => option.value === logService.filter.user_id)}
                    onChange={(selectedOption) => {
                        logService.setFilter(prevState => ({
                        ...prevState,
                        user_id: selectedOption ? selectedOption.value : 0,
                        page: 1,
                        }));
                    }} 
                    isClearable
                    placeholder={t('User')}
                />
              </div>
            </div>


            <div className={cl.col} >
              <div className={cl.inBox}>
                <Select
                    styles={selectStyle}
                    options={options}
                    value={options.find(option => option.value === logService.filter.action_id)}
                    onChange={(selectedOption) => { 
                    logService.setFilter(prevState => ({
                        ...prevState,
                        action_id: selectedOption ? selectedOption.value : 0,
                        page: 1,
                    }));
                    }}
                    isClearable
                    placeholder={t('Actions')}
                /> 
              </div>
            </div>

 



 



     </div>


 
 
    <div className={tbl.table + ' ' + cl.table} style={{ maxHeight: 'calc(100vh - 183px)' }}>
 
      <table>
        <thead>
            <tr> 
              <th className={cl.id}>ID</th> 
              <th>{t('Actions')}</th> 
              <th>{t('User')}</th>  
              <th style={{ display: "none" }}>Item ID</th>


                  {
                      baseFileURL === "https://finance.automoby.ge"  ||  baseFileURL === "https://crm.aig.com.ge"  ||  baseFileURL === "https://crmdev.aig.com.ge"  ||  baseFileURL === "https://crm.autonomo.kz" 
                      ? 
                       <>
                          <th>{t('Car')}</th> 
                       </> 
                      : baseFileURL === "https://i-logistics.net" ||  baseFileURL === "https://dev.i-logistics.net"
                      ? <>
                          <th>{t('Container')}</th> 
                          <th>{t('Cargo')}</th>  
                        </> 
                      : "" 
                  }

 

              <th>{t('Data')}</th>  
              <th>IP</th>  
              <th>{t('Date')}</th> 
            </tr>
        </thead>
        <tbody>
            { logService.items && logService.items.map((item) =>
              <tr key={item.id} > 
                <td className={cl.id} >{item.item_id} </td> 
                <td>
                 {getTypeName(item.type_id)}
                </td> 
                <td>{item.user.firstname + "  " +item.user.lastname } </td>  

                <td style={{ display: "none" }}>{item.item_id}</td> 
 
                  {
                      baseFileURL === "https://finance.automoby.ge"  ||  baseFileURL === "https://crm.aig.com.ge"  ||  baseFileURL === "https://crmdev.aig.com.ge"   ||  baseFileURL === "https://crm.autonomo.kz" 
                      ?
                        <>
                          <td>{item.car_id}</td>  
                        </> 
                      : baseFileURL === "https://i-logistics.net" ||  baseFileURL === "https://dev.i-logistics.net"
                      ? <>
                          <td>{item.container_id}</td>   
                          <td>{item.cargo_id}</td>   
                        </> 
                      : "" 
                  }
  
                <td>
                    <LogItem 
                        key={item.id}
                        item={item}
                    />
                </td>
                <td>{item.ip}</td>

                <td>{formatDate(item.created_at)}</td>
               </tr>  
            )}
        </tbody>
      </table>
 
    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={logService.total} 
                perPage={logService.filter.limit} 
                current={logService.filter.page} 
                paginate={(page) => {
                  logService.setFilter({
                    ...logService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                  logService.setFilter({
                    ...logService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default List;